import { Paciente } from '../../models/Entities/Turnero';
import { CommonState } from '../common/state/commonState';

export interface TurneroPacientesState extends CommonState<Paciente> {
    current: Paciente | undefined;
    enCola: Paciente[];

    isLoadingEnCola: boolean;
    successLoadingEnCola: boolean | undefined;
    failOnLoadingEnCola: boolean;
}

export const TurneroPacientesUnloadState: any = {
    // loading all
    isLoadingAll: false,
    isLoadingAllSuccess: undefined,
    FailGettingAll: false,

    // updating all
    isUpdatingAll: false,
    isUpdatingAllSuccess: undefined,
    FailUpdatingAll: false,

    // loading one
    isLoadingOne: false,
    isLoadingOneSuccess: undefined,
    FailGettingOne: false,

    // updating
    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,
    
    // adding
    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    // deleting
    isDeletingOne: false,
    isDeletingOneSuccess: undefined,
    FailDeletingOne: false,

    // list and error
    list: [],
    error: undefined,

    // custom
    current: undefined,
    enCola: [],

    isLoadingEnCola: false,
    successLoadingEnCola: undefined,
    failOnLoadingEnCola: false
};
